export default __webpack_public_path__ + "static/Scalability-9aa4863615aa6b15cd635fddaf96db5c.svg";